export const SET_FORM_ITEM = "SET_FORM_ITEM";

export interface SetFormItem {
  type: typeof SET_FORM_ITEM;
  formItem: [] | any;
}

export type FormItemTypes = SetFormItem;
